
import { FriendsReferralApiService, IFRInviteeData, IGetInviteesResponse } from '@sitegen/common/classes/friends-referral-api';

import { flatten } from 'lodash';

export const FR_INVITEES_REQUEST_LIMIT = 50;

export const getFRInvitees = async (): Promise<IFRInviteeData[]> => {    
    const { numberOfInvitees, invitees: firstInvitees } = await FriendsReferralApiService.getInvitees({ page: 1 });
    if (numberOfInvitees <= FR_INVITEES_REQUEST_LIMIT) {
        return firstInvitees;
    }

    const pages: number = Math.ceil(numberOfInvitees / FR_INVITEES_REQUEST_LIMIT);
    const promises: Promise<IGetInviteesResponse>[] = [];

    /* Page indexing starts from 1 for this API, and we start from 2 because have already performed 1st request */
    for (let i: number = 2; i <= pages; i++) {
        promises.push(FriendsReferralApiService.getInvitees({ page: i }));
    }

    const otherInviteesResponses = await Promise.all(promises);
    const otherInvitees = otherInviteesResponses.map(({ invitees }) => invitees);
    return flatten([firstInvitees, ...otherInvitees]);
};
